import get from 'lodash/get';
import capitalize from 'lodash/capitalize';

import { DOCUMENTATION_TYPES } from '../constants';

const MAX_FILE_SIZE = 32;

const getDocumentFrontSideText = ({ formatMessage, isEditMode }) => {
  return isEditMode
    ? `${formatMessage({
        id: 'community.newPost.addPhoto',
      })} \n(${formatMessage({ id: 'documentation.common.frontSide' })})`
    : `${capitalize(
        formatMessage({
          id: 'documentation.common.frontSide',
        }),
      )}`;
};

const getDocumentBackSideText = ({ formatMessage, isEditMode }) => {
  return isEditMode
    ? `${formatMessage({
        id: 'community.newPost.addPhoto',
      })} \n(${formatMessage({ id: 'documentation.common.backSide' })})`
    : `${capitalize(
        formatMessage({
          id: 'documentation.common.backSide',
        }),
      )}`;
};

export const getInsuranceCardDocumentsConfig = ({
  formatMessage,
  userDocuments,
  isEditMode,
}) => {
  const getDocumentDataByKey = (key, param) => {
    const document = userDocuments.find(doc => doc.key === key);

    return get(document, param);
  };

  const frontCardUrl = getDocumentDataByKey(
    DOCUMENTATION_TYPES.CARD_1,
    'attachment.thumbMiddle',
  );

  const backCardUrl = getDocumentDataByKey(
    DOCUMENTATION_TYPES.CARD_2,
    'attachment.thumbMiddle',
  );

  const sectionTitle = `${formatMessage({
    id: 'profile.fields.insuranceCard',
  })}  ${isEditMode ? formatMessage({ id: 'common.optional' }) : ''}`;

  return {
    sectionTitle,
    fields: [
      {
        key: DOCUMENTATION_TYPES.CARD_1,
        hideEllipsis: true,
        type: 'image',
        fieldName: DOCUMENTATION_TYPES.CARD_1,
        id: getDocumentDataByKey(DOCUMENTATION_TYPES.CARD_1, 'id'),
        maxFileSize: MAX_FILE_SIZE,
        value: '',
        src: frontCardUrl,
        label: getDocumentFrontSideText({ formatMessage, isEditMode }),
      },
      {
        key: DOCUMENTATION_TYPES.CARD_2,
        hideEllipsis: true,
        type: 'image',
        fieldName: DOCUMENTATION_TYPES.CARD_2,
        id: getDocumentDataByKey(DOCUMENTATION_TYPES.CARD_2, 'id'),
        maxFileSize: MAX_FILE_SIZE,
        value: '',
        src: backCardUrl,
        label: getDocumentBackSideText({ formatMessage, isEditMode }),
      },
    ],
  };
};

export const getDriverLicenseDocumentConfig = ({
  formatMessage,
  userDocuments,
  isEditMode,
}) => {
  const getDocumentDataByKey = (key, param) => {
    const document = userDocuments.find(doc => doc.key === key);
    return get(document, param);
  };

  const extraTitle = isEditMode ? formatMessage({ id: 'common.optional' }) : '';

  const src = getDocumentDataByKey(
    DOCUMENTATION_TYPES.DRIVER_LICENCE,
    'attachment.thumbMiddle',
  );

  const id = getDocumentDataByKey(DOCUMENTATION_TYPES.DRIVER_LICENCE, 'id');

  const text = formatMessage({
    id: 'community.newPost.addPhoto',
  });

  const disabledText = formatMessage({
    id: 'profile.fields.driverLicense',
  });

  const name = `${formatMessage({
    id: 'profile.fields.driverLicense',
  })} ${extraTitle}`;

  const title = formatMessage({ id: 'documentation.common.title' });

  const sectionTitle = `${disabledText}  ${
    isEditMode ? formatMessage({ id: 'common.optional' }) : ''
  }`;

  const label = formatMessage({
    id: 'community.newPost.addPhoto',
  });

  return {
    title,
    sectionTitle,
    fields: [
      {
        name,
        label,
        hideEllipsis: true,
        type: 'image',
        fieldName: DOCUMENTATION_TYPES.DRIVER_LICENCE,
        id,
        limit: MAX_FILE_SIZE,
        value: '',
        src,
        text,
        disabledText,
      },
    ],
  };
};

export const getAdditionalInsuranceCardDocumentsConfig = ({
  formatMessage,
  userDocuments,
  isEditMode,
  fieldName,
}) => {
  const frontSideFieldName = `${fieldName}_1`;
  const backSideFieldName = `${fieldName}_2`;

  const getDocumentDataByKey = (key, param) => {
    const document = userDocuments.find(doc => {
      return doc.key === key;
    });

    return get(document, param);
  };

  const frontCardUrl = getDocumentDataByKey(
    frontSideFieldName,
    'attachment.thumbMiddle',
  );

  const backCardUrl = getDocumentDataByKey(
    backSideFieldName,
    'attachment.thumbMiddle',
  );

  const sectionTitle = `${formatMessage({
    id: 'profile.fields.insuranceCard',
  })}  ${isEditMode ? formatMessage({ id: 'common.optional' }) : ''}`;

  return {
    sectionTitle,
    fields: [
      {
        key: frontSideFieldName,
        hideEllipsis: true,
        type: 'image',
        fieldName: frontSideFieldName,
        id: getDocumentDataByKey(frontSideFieldName, 'id'),
        maxFileSize: MAX_FILE_SIZE,
        value: '',
        src: frontCardUrl,
        label: getDocumentFrontSideText({ formatMessage, isEditMode }),
      },
      {
        key: backSideFieldName,
        hideEllipsis: true,
        type: 'image',
        fieldName: backSideFieldName,
        id: getDocumentDataByKey(backSideFieldName, 'id'),
        maxFileSize: MAX_FILE_SIZE,
        value: '',
        src: backCardUrl,
        label: getDocumentBackSideText({ formatMessage, isEditMode }),
      },
    ],
  };
};



// WEBPACK FOOTER //
// ./src/utils/getDocumentsConfig.js